/**
 * Controls YouTube teaser videos: sizes the iframe, loads the selected video
 * into the modal, and stops playback when the modal is dismissed.
 */
const initializeYouTubeIframe = () => {
    const iframe = document.getElementById('youtube--fullscreen');
    const modal = document.getElementById('modalYouTube');
    const youtubeCheckbox = document.getElementById('checkbox--youTube');
    const resizeIframe = () => {
        if (!iframe) {
            return;
        }

        iframe.style.width = `${document.documentElement.clientWidth}px`;
        iframe.style.height = `${window.innerHeight - 40}px`;
    };

    document.querySelectorAll('.teaser__link').forEach((teaser) => {
        teaser.addEventListener('click', () => {
            resizeIframe();
            window.addEventListener('resize', resizeIframe);
        });
    });

    document.addEventListener('click', (event) => {
        const videoLink = event.target instanceof Element
            ? event.target.closest('a[data-video-id]')
            : null;
        if (!videoLink || event.defaultPrevented) {
            return;
        }

        const videoId = videoLink.dataset.videoId;
        const attribute = youtubeCheckbox?.checked ? 'src' : 'data-src';
        if (iframe) {
            iframe.setAttribute(attribute, `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&playsinline=1&enablejsapi=1`);
        }
        if (modal) {
            window.jQuery(modal).modal('show');
        }
    });

    document.querySelectorAll('button[data-dismiss]').forEach((button) => {
        button.addEventListener('click', () => {
            if (iframe) {
                iframe.contentWindow.postMessage('{"event":"command", "func":"stopVideo", "args":""}', '*');
            }
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeYouTubeIframe);
} else {
    initializeYouTubeIframe();
}
